import type { AfterContentInit, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import type { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { Seo } from '../../seo.service';
import type { FaqStructuredData } from '../structured-data.model';
import { StructuredDataClassName } from '../structured-data.model';
import { FaqItemComponent } from './faq-item.component';

@Component({
  selector: 'fl-seo-faq-schema',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqSchemaComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(FaqItemComponent)
  faqItemComponents: QueryList<FaqItemComponent>;

  private childListSubscription?: Subscription;

  constructor(private seo: Seo) {}

  ngAfterContentInit(): void {
    this.childListSubscription = this.faqItemComponents.changes
      .pipe(startWith(this.faqItemComponents.toArray()))
      .subscribe(components => {
        if (components) {
          const faqSchema = this.buildFaqSchema(components);
          this.seo.insertStructuredData(
            faqSchema,
            StructuredDataClassName.FAQ_SCHEMA,
          );
        }
      });
  }

  ngOnDestroy(): void {
    if (this.childListSubscription) {
      this.childListSubscription.unsubscribe();
    }
  }

  private buildFaqSchema(
    components: readonly FaqItemComponent[],
  ): FaqStructuredData {
    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: components.map((faqItem: FaqItemComponent) => ({
        '@type': 'Question',
        name: faqItem.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faqItem.answer,
        },
      })),
    };
  }
}
